import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import Roadmap from "./Roadmap";
import FeatureRequestsPage from "./FeatureRequestsPage";

const PRIMARY_COLOR = "#bb1ccc";

function TabPanel({ children, value, index }) {
  return (
    <Box
      sx={{ pt: 2, display: value === index ? "block" : "none" }}
      role="tabpanel"
      aria-hidden={value !== index}
    >
      {children}
    </Box>
  );
}

const TabsLayout = ({ children }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", background: "transparent" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Feature tabs"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: PRIMARY_COLOR,
            },
          }}
        >
          <Tab
            label="Feature Requests"
            sx={{
              textTransform: "none",
              color: "#6B7280",
              "&.Mui-selected": {
                color: PRIMARY_COLOR,
              },
              fontSize: "14px"
            }}
          />
          <Tab
            label="Roadmap"
            sx={{
              textTransform: "none",
              color: "#6B7280",
              "&.Mui-selected": {
                color: PRIMARY_COLOR,
              },
              fontSize: "14px"
            }}
          />
        </Tabs>

      </Box>

      <TabPanel value={value} index={0}>
        <FeatureRequestsPage />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <Roadmap />
      </TabPanel>
    </Box>
  );
};

export default TabsLayout;
